import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from './Icons';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-white/5 rounded-xl bg-bg-card/50 overflow-hidden" data-id="element-28">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 px-6 sm:px-8 py-5 sm:py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50 focus-visible:ring-inset transition-colors duration-200" aria-expanded={isOpen} data-id="element-29">
        <span className="font-serif text-lg sm:text-xl font-semibold text-cream leading-snug" data-id="element-30">
          {question}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0" data-id="element-31">
          <ChevronDownIcon className="w-5 h-5 text-cream-muted" data-id="element-32" />
        </motion.span>
      </button>

      <AnimatePresence initial={false} data-id="element-33">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-34">
            <div className="px-6 sm:px-8 pb-6 sm:pb-8" data-id="element-35">
              <div className="h-px bg-white/5 mb-5" data-id="element-36" />
              <p className="font-sans text-base text-cream-muted leading-relaxed" data-id="element-37">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="relative w-full bg-bg-primary py-20 sm:py-28" aria-label="Frequently asked questions" data-id="element-38">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-39">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-40">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-cream" data-id="element-41">
            Frequently Asked Questions
          </h2>
        </motion.div>

        {/* FAQ items */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="space-y-4" data-id="element-42">
          <FAQItem question={'"Is this raw feeding?"'} answer="No, it's a hybrid approach. You keep your kibble but supercharge it with specific anti-inflammatory toppers that cost pennies per serving. No need to overhaul your dog's entire diet." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-43" />

          <FAQItem question={'"I\'m busy. Does this take long?"'} answer="15 minutes of prep for the entire week. That's it. We designed the Hybrid Bowl Method for real people with real schedules — not Instagram chefs with unlimited free time." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-44" />

          <FAQItem question={'"Will my vet agree?"'} answer="We teach you the science so you can have a real conversation with your vet about anti-inflammatory markers, omega-3 ratios, and bioavailable nutrients. Most vets are thrilled when owners take an active, informed role in their dog's nutrition." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-45" />
        </motion.div>
      </div>
    </section>;
}